const state = function () {
  return {
    token: null,
  };
};

const mutations = {
  SET_TOKEN: function (state, token) {
    state.token = token;
  },

  RESET_TOKEN: function (state) {
    state.token = null;
  },
};

const getters = {
  getToken: (state) => state.token,
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {},
};